<div *ngIf="zipProgress" class="loading-box">
    <div class="loading-content">
        <!-- Animated spinner -->
        <div class="spinner"></div>
        <div *ngIf="isTotalSizeAvailable()" style="position: relative; width: 100%; padding: 10px; text-align: center;">
            <p>Downloading, please wait...</p>
            <div style="width: 100%; height: 4px; background-color: #ddd; position: relative; border-radius: 2px;">
                <div [style.width.%]="(downloadedZipBytes / totalSizeInBytes()) * 100"
                    style="height: 100%; background-color: #007bff; transition: width 0.3s ease-in-out; border-radius: 2px;">
                </div>
            </div>
        </div>
        <p *ngIf="!isTotalSizeAvailable()">Downloading, please wait.. [{{formatSize(downloadedZipBytes)}}]</p>

        <button class="cancel-button" (click)="cancelDownload()">Cancel</button>
    </div>
</div>
<div class="upload-study-modal">
    <div class="modal-header">

        <h4 class="modal-title">Download Clinical Study Data</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="closePopup()"></button>
    </div>
    <div class="modal-body">
        <div class="container">

            <!-- X-Ray Images Section -->
            <div class="mb-4" *ngIf="fileInfo?.xrayCount > 0">
                <h5>X-Ray Images</h5>
                <div class="d-flex justify-content-between align-items-center">
                    <span>{{fileInfo?.xrayCount}} Images</span>
                    <button class="btn btn-primary" (click)="downloadDicomFiles(false)">Download (DCM)</button>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-2">
                    <span>{{fileInfo?.xrayCount}} Images</span>
                    <button class="btn btn-primary" (click)="downloadDicomFiles(true)">Download (JPG)&nbsp;</button>
                </div>
            </div>
            <hr *ngIf="fileInfo?.xrayCount > 0" />
            <!-- Media Section -->
            <div class="mb-4" *ngIf="fileInfo?.scopeFiles.length > 0">
                <h5>Media</h5>

                <div class="d-flex justify-content-between align-items-center mt-2 me-2"
                    *ngFor="let media of fileInfo?.scopeFiles">
                    <span>{{media.documentTypeName}}</span>
                    <button class="btn btn-primary" style="max-height: 40px;"
                        (click)="downloadStudyFile(media.thumbURL,media.originalFileName)">Download</button>
                </div>
            </div>
            <hr *ngIf="fileInfo?.scopeFiles.length > 0" />
            <!-- Reports Section -->
            <div *ngIf="fileInfo?.reportFiles.length > 0">
                <h5>Reports</h5>

                <div class="d-flex justify-content-between align-items-center mt-2 me-2"
                    *ngFor="let report of fileInfo?.reportFiles">
                    <span>{{report.documentTypeName}}</span>
                    <button class="btn btn-primary"  style="max-height: 40px;"
                        (click)="downloadStudyFile(report.thumbURL,report.originalFileName)">Download</button>
                </div>
            </div>
            <hr *ngIf="fileInfo?.reportFiles.length > 0" />
        </div>

    </div>

</div>
